module.exports = __webpack_public_path__ + "img/5.ab3874c3.png";